module.exports = __webpack_public_path__ + "static/media/wmgr_headset_setup_body_analytics.d73e19b4.png";